
import React, {FC} from 'react';
import {useQualifier} from 'components/Assistant/_Qualifier/useQualifier';
import {Chat} from 'components/ContentPagesComponents/Assistant/Shared/Chat';
import {Layout} from 'components/ContentPagesComponents/Assistant/Shared/Layout';
import {LeftImage} from 'components/ContentPagesComponents/Assistant/Shared/LeftImage';
import {BG} from 'constants/index';

import LearnIcon from './svgs/learn.inline.svg';

type SalesQualifierProps = {
	bg?: BG
	title: string
}

export const SalesQualifier: FC<SalesQualifierProps> = ({
	bg = BG.transparent,
	title,
}) => {
	const assistant = useQualifier();
	const bgURL = 'https://static.bodyspec.com/at/c7/ae/c7ae2741d7091ab2';
	return (
		<Layout bg={bg} title={title}>
			<LeftImage imageSrc={bgURL}>
				<LearnIcon />
				<h1>Simple to host, impossible to forget</h1>
				<h2>The DEXA van directly comes to you</h2>
			</LeftImage>
			<Chat
				assistant={assistant}
				track='ai:sales'
			/>
		</Layout>
	);
};
